//
//
//
//
//
//

import {base} from '../../common/mixins'
import Cell from './Cell'

export default {
  Cell,
  name: 'Group',
  mixins: [base],
  props: {},
  data () {
    return {}
  },
  mounted () {},
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Group/index.vue